import { render, staticRenderFns } from "./DSRDetails.vue?vue&type=template&id=40c40845&"
import script from "./DSRDetails.vue?vue&type=script&lang=js&"
export * from "./DSRDetails.vue?vue&type=script&lang=js&"
import style0 from "./DSRDetails.vue?vue&type=style&index=0&id=40c40845&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VForm,VOverlay,VProgressCircular,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c40845')) {
      api.createRecord('40c40845', component.options)
    } else {
      api.reload('40c40845', component.options)
    }
    module.hot.accept("./DSRDetails.vue?vue&type=template&id=40c40845&", function () {
      api.rerender('40c40845', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/edit/DSRDetails.vue"
export default component.exports